import { Injectable } from '@angular/core';

import { FixtureState, OfferMapping, ScoreboardMode, ShowcaseRequest } from '@cds/query-objects';
import { ShowcaseConfig } from '@frontend/sports/common/client-config-data-access';
import { flatten } from 'lodash-es';

import { IShowcaseRequest, Lobby, LobbySpecificRequest } from './showcase.model';
import { ShowcaseService } from './showcase.service';

@Injectable({ providedIn: 'root' })
export class ShowcaseRequestBuilderService {
    constructor(
        private showcaseService: ShowcaseService,
        private showcaseConfig: ShowcaseConfig,
    ) {}

    getRequestPayload(data: LobbySpecificRequest): ShowcaseRequest {
        if (this.showcaseConfig.isShowcaseModuleEnabled) {
            const showcaseData = this.showcaseService.getLobbySpecificData(data);

            return this.buildRequestForLobby(showcaseData.request, data.lobby);
        }

        return { queries: [], getOnlyFirstAvailableOffer: false };
    }

    private buildRequestForLobby(showcaseData: IShowcaseRequest[], lobby: Lobby): ShowcaseRequest {
        return {
            queries: flatten(
                showcaseData.map((m) =>
                    m.fixturesGroup.map((tab) => {
                        return {
                            fixtureIds: tab.fixtureId,
                            gridGroupIds: this.showcaseService.getGridGroupIds(tab.gridGroup).join(','),
                            requestId: m.requestId + '',
                            scoreboardMode: ScoreboardMode.Full,
                            offerMapping: OfferMapping.Filtered,
                            state: FixtureState.Latest,
                        };
                    }),
                ),
            ),
            getOnlyFirstAvailableOffer: lobby !== Lobby.Competition,
        };
    }

    buildRequestForOptionGroup(fixtureId: string, groupIds: string[]): ShowcaseRequest {
        return {
            queries: [
                {
                    fixtureIds: fixtureId,
                    gridGroupIds: groupIds.join(','),
                    requestId: '',
                    offerMapping: OfferMapping.Filtered,
                    state: FixtureState.Latest,
                },
            ],
            getOnlyFirstAvailableOffer: true,
        };
    }
}
